<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>

<script setup>
  import { useHead } from '#imports'

  const scroll = useScrollStore()
  const layout = useLayoutStore()
  const globals = useGlobalStore()
  const route = useRoute()
  const env = useRuntimeConfig().public

  if (Object.keys(route.query)?.length) {
    useRobotsRule('noindex, nofollow')
  }

  useHead(() => ({
    title: globals.seo?.title ?? globals.title,
    link: [
      {
        rel: 'icon', type: 'image/png', sizes: '96x96', href: '/favicon-96x96.png'
      },
      {
        rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg'
      },
      {
        rel: 'shortcut icon', href: '/favicon.ico'
      },
      {
        rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png'
      },
      { rel: 'manifest', href: '/site.webmanifest' }
    ],
    meta: [
      { name: 'msapplication-TileColor', content: '#db0812' },
      { name: 'apple-mobile-web-app-title', content: 'Veneta Cucine' },
      { name: 'theme-color', content: '#db0812' }
    ],
    htmlAttrs: {
      class: { '-is-dev': env.DEV }
    },
    bodyAttrs: {
      class: {
        'scroll-lock': scroll.locked,
        'page-transitioning': layout.transitioning,
        'is-landing': layout.isLanding
      }
    }
  }))
</script>
